export class ThemesListAnimations{
	init() {
		var elem = $('.themes-list-heading, .themes-icons__item, .themes-list__item, .themes-list__logotype');
		var self = this;

		this.delay($('.themes-list-heading span'));
		this.delay($('.themes-icons .themes-icons__item'));
		this.delayShort($('.themes-list .themes-list__item'));
		$(document).ready(function() {
			setTimeout(function() {
				self.checkIfVisible(elem);

				$(window).scroll(function() {
					self.checkIfVisible(elem);
				});
				$('.themes-icons').scroll(function() {
					self.checkIfVisible(elem);
				});
					
			}, 500)
		})
	}
	checkIfVisible(elem){
		elem.each(function() {
			var $this = $(this),
				elemVisible = $this.visible(true, 'vertical');

			if(elemVisible){
				$this.addClass('on-screen', elemVisible);
				setTimeout(function() {
					$this.addClass('triggered');
				}, 500);
			}
		});
	}
	delay(elem){
		elem.each(function(index) {
			$(this).css('transition-delay', (300+(150*index) + 'ms'));
		});
	}
	delayShort(elem){
		elem.each(function(index) {
			$(this).css('transition-delay', ((50*index) + 'ms'));
		});
	}
}